var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ButtonComponent_1;
import { css, html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { Icon } from '../../utils/icon-utils.js';
import { Translate } from '../../utils/translate.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
let ButtonComponent = class ButtonComponent extends GGOBaseComponent {
    static { ButtonComponent_1 = this; }
    static { this.VALIDATE = 'validate'; }
    static { this.CANCEL = 'cancel'; }
    static { this.ACTION = 'action'; }
    static { this.NEUTRAL = 'neutral'; }
    static { this.ADD = 'add'; }
    static { this.ICON = 'icon'; }
    constructor() {
        super();
        /**
         * @deprecated Use slot instead
         */
        this.label = '';
        this.variant = ButtonComponent_1.ACTION;
        this.icon = '';
        this.title = '';
        this.disabled = false;
        this.iconPosition = 'left';
        this.isLoading = false;
        if (!this.iconPosition) {
            this.iconPosition = 'left';
        }
    }
    static get styles() {
        return [
            ...super.styles,
            css `
        // .square_button {
        //   display: flex;
        // }
        .slds-button.slds-button_icon.square_button {
          height: 1.5rem;
          width: 1.5rem;
        }
        .slds-button.square_button:hover {
          box-shadow:rgba(0, 0, 0, 0.15) 1px 1px 2px;
        }
        .slds-button:active.square_button {
          border-color: #1b96ff;
        }
      `,
        ];
    }
    getVariantClass() {
        switch (this.variant) {
            case ButtonComponent_1.NEUTRAL:
                return '';
            case ButtonComponent_1.VALIDATE:
                return 'slds-button_brand';
            case ButtonComponent_1.CANCEL:
                return 'slds-button_neutral';
            case ButtonComponent_1.ACTION:
                return 'slds-button_neutral';
            case ButtonComponent_1.ADD:
                return 'slds-button_outline-brand';
            case ButtonComponent_1.ICON:
                return 'slds-button_icon';
            default:
                return 'slds-button_brand';
        }
    }
    getIconTemplate() {
        const classes = ['slds-button__icon'];
        if ((this.label && this.icon) || this.variant === ButtonComponent_1.ADD) {
            classes.push('slds-button__icon_' + this.iconPosition);
        }
        if (this.variant === ButtonComponent_1.ADD) {
            this.icon = 'add';
        }
        return this.icon
            ? Icon.getSVGIconTag({
                icon: this.icon,
                sprite: 'utility',
                classes: classes,
            })
            : nothing;
    }
    getLabel() {
        if (!this.label || this.label === '') {
            switch (this.variant) {
                case ButtonComponent_1.VALIDATE:
                    return Translate.get('btn_validate');
                case ButtonComponent_1.CANCEL:
                    return Translate.get('btn_cancel');
                case ButtonComponent_1.ADD:
                    return 'Add';
                default:
                    return '';
            }
        }
        return this.label ? this.label : '';
    }
    render() {
        return html `
      <button
        title="${this.title.length > 0 ? this.title : this.label}"
        class="slds-button ${this.getVariantClass()} ${!this.label && this.icon ? 'square_button' : ''}"
        @click="${this._handleClick}"
        ?disabled=${this.disabled || this.isLoading}
      >
        ${this.getButtonContent()}
      </button>
    `;
    }
    getButtonContent() {
        return html `
      ${this.iconPosition === 'left' ? this.getIconTemplate() : nothing} ${this.getLabel()}<slot></slot>
      ${this.iconPosition !== 'left' ? this.getIconTemplate() : nothing}
    `;
    }
    async _handleClick(e) {
        console.log('clicked', e);
        if (this.onclick) {
            this.isLoading = true;
            try {
                await this.onclick(e);
            }
            finally {
                this.isLoading = false;
            }
        }
        else {
            let click = new Event('onclick');
            this.dispatchEvent(click);
        }
    }
};
__decorate([
    property({ type: String })
], ButtonComponent.prototype, "label", void 0);
__decorate([
    property({ type: String })
], ButtonComponent.prototype, "variant", void 0);
__decorate([
    property({ type: String })
], ButtonComponent.prototype, "icon", void 0);
__decorate([
    property({ type: String })
], ButtonComponent.prototype, "title", void 0);
__decorate([
    property({ type: Boolean })
], ButtonComponent.prototype, "disabled", void 0);
__decorate([
    property({ type: Function })
], ButtonComponent.prototype, "onclick", void 0);
__decorate([
    property({ type: String })
], ButtonComponent.prototype, "iconPosition", void 0);
__decorate([
    state()
], ButtonComponent.prototype, "isLoading", void 0);
ButtonComponent = ButtonComponent_1 = __decorate([
    customElement('ggo-button')
], ButtonComponent);
export { ButtonComponent };
